import { useParams, Link } from "react-router-dom";
import SEO from "@/components/SEO";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    body: "ImJove Tech respects your privacy. We collect only the information needed to respond to inquiries and improve our platforms. We do not sell personal data. Contact us for any privacy-related requests.",
  },
  terms: {
    title: "Terms of Service",
    body: "By using ImJove Tech websites and platforms you agree to use them lawfully and respectfully. All content and trademarks are the property of ImJove Tech unless otherwise noted.",
  },
  cookies: {
    title: "Cookie Policy",
    body: "We use minimal cookies to keep the experience functional and to understand aggregate usage. You can control cookies through your browser settings.",
  },
};

export default function Legal() {
  const { doc } = useParams();
  const c = CONTENT[doc] || CONTENT.privacy;
  return (
    <div className="mx-auto max-w-[820px] px-6 pb-28 pt-40 md:px-12">
      <SEO title={`${c.title} — ImJove Tech`} description={c.body.slice(0, 150)} />
      <Link to="/" className="font-mono2 text-[11px] uppercase tracking-widest text-white/40 hover:text-white">← Home</Link>
      <h1 className="mt-6 font-display text-5xl font-bold tracking-tighter text-white">{c.title}</h1>
      <p className="mt-8 font-body text-lg leading-relaxed text-white/60">{c.body}</p>
      <p className="mt-6 font-body text-white/40">Last updated {new Date().getFullYear()}. For questions, reach us via the <Link to="/contact" className="text-gold-light">Contact</Link> page.</p>
    </div>
  );
}
